import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { forYouList } from '../data/content';
export function ForYouSection() {
  return <section className="w-full bg-ivory py-20 md:py-28" aria-labelledby="para-ti" data-id="element-107" data-mp="2cv9amqyzyd6a">
      <div className="mx-auto max-w-4xl px-6 lg:px-8" data-id="element-108" data-mp="2htud6x1q18xw">
        <SectionHeading eyebrow="Para ti" title={<span id="para-ti" data-id="element-110" data-mp="1l3jvp2oxa777">Esto es para ti si…</span>} data-id="element-109" data-mp="2hvf329d3c3pf" />

        <ul className="mt-14 grid gap-4 sm:grid-cols-2" data-id="element-111" data-mp="1l54ux5m6mebe">
          {forYouList.map((item, i) => <Reveal key={item} delay={i * 0.06} data-id="element-112" data-mp="1p4x33h7nyig8" data-mpi={i}>
              <li className="flex h-full items-start gap-4 rounded-2xl border border-sand bg-shell/50 px-6 py-6 transition-colors duration-500 hover:border-goldsoft" data-id="element-113" data-mp="1u36zfv54jp3f">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-goldsoft" data-id="element-114" data-mp="1z0gnp7gs1upo">
                  <CheckIcon className="h-3 w-3 text-gold" data-id="element-115" data-mp="3ahgnsp9d9du9" />
                </span>
                <span className="font-sans text-[0.97rem] font-light leading-relaxed text-ink" data-id="element-116" data-mp="5lyu0bqy5nfh">
                  {item}
                </span>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}